import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import './index.css';
import { Home, Login, Auth, Dashboard } from './components';
import { Annotators } from './components/Dashboard/index'
import { Overview } from "./components/Dashboard/Overview";
import App from './App';

const rootElement = document.getElementById("root");

render(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="dashboard" element={<Dashboard />}>
            <Route index element={<Overview />} / >
            <Route path="annotators" element={<Annotators />} />
        </Route>    
      </Routes>
    </BrowserRouter>,
  rootElement
);
